import React from "react";
import { useForm } from "react-hook-form";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import { createUserData } from "../../..//features/userBlock/userBlockSlice";
import Images from "../../../media/images";
import { toast } from "react-toastify";

const CreateUser = () => {
  const { register, handleSubmit } = useForm();
  const dispatch = useDispatch();

  const handleClick = (data) => {
    data.user_type = "ST";
  
    dispatch(createUserData(data));
    

  };

  return (
    <form onSubmit={handleSubmit(handleClick)}>
      <div className="">
        <h1 className="text-primary-red mt-2 text-center text-3xl font-bold lg:!mt-6">
          Create User
        </h1>
        <div className="">
          <img src={Images.title_border} alt="" className="mx-auto mt-4" />
        </div>
        <div className="mt-5 p-3 md:!px-10">
          <div className="grid md:grid-cols-2">
            <div className="border-primary-blue flex items-center gap-2 border-2 border-b-0 md:border-b-2 md:border-r-0 p-2">
              <label htmlFor="" className="text-primary-red">
                First Name
              </label>
              <input
                type="text"
                className="flex-grow py-2 px-2 outline-none"
                {...register(`f_name`, {
                  // required: false,
                })}
                placeholder="First Name"
              />
            </div>
            <div className="border-primary-blue flex items-center gap-2 border-2  p-2">
              <label htmlFor="" className="text-primary-red">
                Last Name
              </label>
              <input
                type="text"
                name=""
                className="flex-grow py-2 px-2 outline-none"
                id=""
                {...register(`l_name`, {
                  // required: false,
                })}
                placeholder="Last Name"
              />
            </div>
            <div className="border-primary-blue flex items-center gap-2 border-2 border-t-0 md:border-r-0 p-2 md:!border-l-2">
              <label htmlFor="" className="text-primary-red">
                Address:
              </label>
              <input
                type="text"
                name=""
                className="flex-grow py-2 px-2 outline-none"
                placeholder="Address"
                {...register(`address`, {
                  // required: false,
                })}
              />
            </div>
            <div className="border-primary-blue flex items-center gap-2 border-2 border-t-0 p-2">
              <label htmlFor="" className="text-primary-red">
                Email:
              </label>
              <input
                type="email"
                name=""
                className="flex-grow py-2 px-2 outline-none"
                placeholder="Email"
                {...register(`email`, {
                  // required: false,
                })}
              />
            </div>
            <div className="border-primary-blue flex flex-wrap items-center gap-2 md:border-r-0 border-2 border-t-0 p-2 md:border-l-2">
              <label htmlFor="" className="text-primary-red">
                Mobile Number:
              </label>
              <input
                type="number"
                {...register(`phone`, {
                  // required: false,
                })}
                className="flex-grow py-2 px-2 outline-none"
                placeholder="Phone Number"
              />
            </div>
            <div className="border-primary-blue flex items-center gap-2 border-2 border-t-0 p-2">
              <label htmlFor="" className="text-primary-red">
                PAN No
              </label>
              <input
                type="text"
                {...register(`pan_number`, {
                  // required: false,
                })}
                className="flex-grow py-2 px-2 outline-none"
                placeholder="{111111111}"
              />
            </div>

            <div className="border-primary-blue flex items-center gap-2 border-2 border-t-0 p-2 md:border-r-0">
              <label htmlFor="" className="text-primary-red">
                Citizenship
              </label>
              <input
                type="text"
                {...register(`citizen_number`, {
                  // required: false,
                })}
                className="flex-grow py-2 px-2 outline-none"
                placeholder="{111111111}"
              />
            </div>

            {/* <div className="border-primary-blue flex items-center gap-2 border-2 border-t-0 p-2 md:border-l-0">
            <label htmlFor="" className="text-primary-red">
              Login Type:
            </label>
            <div className="flex flex-wrap items-center gap-2">
              <div className="border-primary-blue flex-shrink-0 rounded-full border px-2 py-1">
                <label className="text-primary-red" htmlFor="">
                  Email
                </label>
                <input type="radio" name="user-id" id="" 
                
                />
                <label className="text-primary-red" htmlFor="">
                  Number:
                </label>
                <input type="radio" name="user-id" id="" />
              </div>
              <input
                type="text"
                className="outline-none"
                placeholder="user id"
                name=""
                id=""
              />
            </div>
          </div> */}
            <div className="border-primary-blue flex items-center gap-2 border-2 border-t-0 p-2">
              <label htmlFor="" className="text-primary-red">
                Password:
              </label>
              <input
                type="text"
                name=""
                className="flex-grow py-2 px-2 outline-none"
                placeholder="Password"
                {...register("password", { required: false })}
              />
            </div>
            <div className="border-primary-blue flex items-center gap-2 border-2 border-t-0 p-2 md:border-r-0 sm:!border-l-">
              <label htmlFor="" className="text-primary-red">
                Confirm Password:
              </label>
              <input
                type="text"
                name=""
                className="flex-grow py-2 px-2 outline-none"
                placeholder=""
                {...register("confirm_password", { required: false })}
              />
            </div>
            <div className="border-primary-blue flex items-center gap-2 border-2 border-t-0 p-2 sm:!border-l-">
              <label htmlFor="" className="text-primary-red">
                Other Details:
              </label>
              <input
                type="text"
                name=""
                className="flex-grow py-2 px-2 outline-none"
                placeholder=""
              />
            </div>
          </div>
        </div>
      </div>
      <button
        className="bg-primary-blue ml-10 mt-3 inline-flex gap-2 rounded-md px-5 py-3 font-bold text-white"
        type="submit"
      >
        Submit
      </button>
    </form>
  );
};

export default CreateUser;
